import React, { createContext, useState, useContext, ReactNode, useEffect } from 'react';

interface FAQContextData {
  hash: string;
  changeHash: (hash: string) => void;
  selectedTab: number;
  selectedSubTab: number;
}

export const FAQContext = createContext<FAQContextData>(
  {} as FAQContextData,
);

export const FAQProvider = ({ children }: { children: ReactNode }) => {
  const [hash, setHash] = useState('')
  const [selectedTab, setSelectedTab] = useState(0)
  const [selectedSubTab, setSelectedSubTab] = useState(0)

  const changeHash = (hash: string) => {
    setHash(hash)
  };

  useEffect(() => {
    const [, sectionIndex, subSectionIndex] = hash.split("-");
    setSelectedTab(Number(sectionIndex) - 1)
    setSelectedSubTab(Number(subSectionIndex) - 1)
  }, [hash]);

  return (
    <FAQContext.Provider
      value={{
        hash,
        changeHash,
        selectedTab,
        selectedSubTab,
      }}
    >
      {children}
    </FAQContext.Provider>
  );
};

export function useFAQ(): FAQContextData {
  const context = useContext(FAQContext);

  if (!context) {
    throw new Error('UseFAQ must be used within an UseFAQProvider');
  }

  return context;
}